@if (LessonContentLoaded) {
  <div class="content">
    @if (EditMode) {
      <h1 class="page-title f-title">
        Контент урока
        <div
          class="open"
          (click)="OpenLesson()"
          containerClass="customClass"
          tooltip="Открыть в режиме просмотра"
          [placement]="'bottom'"
          triggers="hover"
          >
          <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.9979 0.666748C12.2526 0.666748 8.93369 2.62979 6.43791 4.72216C3.91793 6.83482 2.05338 9.23353 1.19186 10.4318C0.514171 11.3744 0.514172 12.6257 1.19186 13.5683C2.05338 14.7666 3.91793 17.1653 6.43791 19.278C8.93369 21.3704 12.2526 23.3334 15.9979 23.3334C19.7432 23.3334 23.0621 21.3704 25.5579 19.278C28.0779 17.1653 29.9424 14.7666 30.8039 13.5683C31.4816 12.6257 31.4816 11.3744 30.8039 10.4318C29.9424 9.23353 28.0779 6.83482 25.5579 4.72216C23.0621 2.62979 19.7432 0.666748 15.9979 0.666748ZM15.9985 19.0834C19.9106 19.0834 23.0819 15.9121 23.0819 12.0001C23.0819 8.08806 19.9106 4.91675 15.9985 4.91675C12.0865 4.91675 8.9152 8.08806 8.9152 12.0001C8.9152 15.9121 12.0865 19.0834 15.9985 19.0834Z"
              fill="white"/>
            <path
              d="M20.2485 12.0001C20.2485 14.3473 18.3457 16.2501 15.9985 16.2501C13.6513 16.2501 11.7485 14.3473 11.7485 12.0001C11.7485 9.65287 13.6513 7.75008 15.9985 7.75008C18.3457 7.75008 20.2485 9.65287 20.2485 12.0001Z"
              fill="white"/>
          </svg>
        </div>
      </h1>
    }
    @if (isSaving) {
      <p class="saving">Сохранение...</p>
    }
    @if (Templates.length == 0) {
      <div>
        <p>Нет контента урока. {{EditMode ? 'Добавьте новый блок.' : '' }}</p>
      </div>
    }
    @if (Templates.length > 0) {
      <div
        cdkDropList
        [cdkDropListData]="Structure"
        [cdkDropListDisabled]="!EditMode"
        (cdkDropListDropped)="onRowDropped($event)"
        >
        @for (row of Structure; track trackByRow(i, row); let i = $index) {
          <div
            class="custom-row"
            cdkDrag
            [cdkDragData]="row"
            [cdkDragDisabled]="!EditMode">
            <div class="row-items">
              @for (col of row; track trackByCol($index, col)) {
                <div
                  class="item"
             [ngClass]="{
                'selected': SelectedItem && SelectedItem.uuid == col.uuid,
                 'edited': EditMode,
                 'one-element':row.length === 1,
                 'two-elements':row.length === 2,
                 'three-elements':row.length === 3
                 }"
                  >
                  <div class="content" [ngClass]="{'content-editable':EditMode}" (click)="SelectItem(col)">
                    <app-lesson-content-item
                      [ItemUid]="col.uuid"
                      [ItemType]="col.type"
                      [ItemData]="col.data"
                      [EditMode]="EditMode"
                      [LessonId]="LessonId"
                      [IsSelected]="(SelectedItem && (SelectedItem.uuid == col.uuid)) ?? false"
                      [buttonName]="col['buttonName']"
                      [scale]="col.scale"
                      (OnChanged)="col.data = $event; SelectedItem = null"
                      (OnChangedFile)="col.data = $event['data'];col.buttonName = $event['buttonName']; SelectedItem = null"
                      >
                    </app-lesson-content-item>
                    @if (EditMode &&  (SelectedItem == null || SelectedItem.uuid !== col.uuid)) {
                      <p class="edit-text">Нажмите
                      для редактирования</p>
                    }
                  </div>
                  @if (SelectedItem && SelectedItem.uuid == col.uuid) {
                    <div class="controls">
                      <div (click)="SelectedItem = null" class="control"><img class="image"
                        src="assets/icons/lesson-content/square-close.svg">
                      </div>
                      <div (click)="deleteItemClick(col)" class="control"><img class="delete" src="assets/icons/delete.svg"></div>
                    </div>
                  }
                </div>
              }
            </div>
            @if (EditMode) {
              <div class="order-wrap">
                <span class="drag-row-handle" cdkDragHandle (click)="$event.stopPropagation()" triggers="hover">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="6" cy="5" r="1.5" fill="currentColor"/>
                    <circle cx="14" cy="5" r="1.5" fill="currentColor"/>
                    <circle cx="6" cy="10" r="1.5" fill="currentColor"/>
                    <circle cx="14" cy="10" r="1.5" fill="currentColor"/>
                    <circle cx="6" cy="15" r="1.5" fill="currentColor"/>
                    <circle cx="14" cy="15" r="1.5" fill="currentColor"/>
                  </svg>
                </span>
                <!-- <span [ngClass]="{'disabled': i == 0}" (click)="$event.stopPropagation(); upBlock(row, i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>
              </span>
              <span [ngClass]="{'disabled': i == Structure.length -1}"  (click)="$event.stopPropagation(); downBlock(row, i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>
              </span> -->
            </div>
          }
        </div>
      }
    </div>
  }
  <br>
    @if (EditMode) {
      <div class="add-tools-block">
        <!-- *ngIf="SelectedItem" -->
        <div [hidden]="!SelectedItem" class="add-tools fixed">
          <div (click)="OpenLesson()" class="button">
            <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.9979 0.666748C12.2526 0.666748 8.93369 2.62979 6.43791 4.72216C3.91793 6.83482 2.05338 9.23353 1.19186 10.4318C0.514171 11.3744 0.514172 12.6257 1.19186 13.5683C2.05338 14.7666 3.91793 17.1653 6.43791 19.278C8.93369 21.3704 12.2526 23.3334 15.9979 23.3334C19.7432 23.3334 23.0621 21.3704 25.5579 19.278C28.0779 17.1653 29.9424 14.7666 30.8039 13.5683C31.4816 12.6257 31.4816 11.3744 30.8039 10.4318C29.9424 9.23353 28.0779 6.83482 25.5579 4.72216C23.0621 2.62979 19.7432 0.666748 15.9979 0.666748ZM15.9985 19.0834C19.9106 19.0834 23.0819 15.9121 23.0819 12.0001C23.0819 8.08806 19.9106 4.91675 15.9985 4.91675C12.0865 4.91675 8.9152 8.08806 8.9152 12.0001C8.9152 15.9121 12.0865 19.0834 15.9985 19.0834Z"
                fill="white"/>
              <path
                d="M20.2485 12.0001C20.2485 14.3473 18.3457 16.2501 15.9985 16.2501C13.6513 16.2501 11.7485 14.3473 11.7485 12.0001C11.7485 9.65287 13.6513 7.75008 15.9985 7.75008C18.3457 7.75008 20.2485 9.65287 20.2485 12.0001Z"
                fill="white"/>
            </svg>
          </div>
          <img class="image" src="assets/icons/lesson-content/replace.svg">
          <div (click)="AddBlock('TEXT')" class="button">
            <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.75 2.79175C8.75 3.96758 9.69917 4.91675 10.875 4.91675H15.8333V19.7917C15.8333 20.9676 16.7825 21.9167 17.9583 21.9167C19.1342 21.9167 20.0833 20.9676 20.0833 19.7917V4.91675H25.0417C26.2175 4.91675 27.1667 3.96758 27.1667 2.79175C27.1667 1.61591 26.2175 0.666748 25.0417 0.666748H10.875C9.69917 0.666748 8.75 1.61591 8.75 2.79175ZM2.375 12.0001H4.5V19.7917C4.5 20.9676 5.44917 21.9167 6.625 21.9167C7.80083 21.9167 8.75 20.9676 8.75 19.7917V12.0001H10.875C12.0508 12.0001 13 11.0509 13 9.87508C13 8.69925 12.0508 7.75008 10.875 7.75008H2.375C1.19917 7.75008 0.25 8.69925 0.25 9.87508C0.25 11.0509 1.19917 12.0001 2.375 12.0001Z"
                fill="white"/>
            </svg>
            <!--<img class="image" src="assets/icons/lesson-content/text.svg">-->
          </div>
          <div (click)="AddBlock('FILE')" class="button">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.25 13C0.25 7.68788 0.25 5.03182 1.6028 3.16985C2.03969 2.56852 2.56852 2.03969 3.16985 1.6028C5.03182 0.25 7.68788 0.25 13 0.25C18.3121 0.25 20.9682 0.25 22.8301 1.6028C23.4315 2.03969 23.9603 2.56852 24.3972 3.16985C25.75 5.03182 25.75 7.68788 25.75 13C25.75 14.1885 25.75 15.2441 25.7348 16.1875L25.6355 16.1875C24.4285 16.1874 23.6933 16.1873 23.059 16.2878C19.5735 16.8398 16.8398 19.5735 16.2878 23.059C16.1873 23.6933 16.1874 24.4285 16.1875 25.6355L16.1875 25.7348C15.2441 25.75 14.1885 25.75 13 25.75C7.68788 25.75 5.03182 25.75 3.16985 24.3972C2.56852 23.9603 2.03969 23.4315 1.6028 22.8301C0.25 20.9682 0.25 18.3121 0.25 13ZM7.33333 6.27083C6.74653 6.27083 6.27083 6.74653 6.27083 7.33333C6.27083 7.92014 6.74653 8.39583 7.33333 8.39583H11.5833C12.1701 8.39583 12.6458 7.92014 12.6458 7.33333C12.6458 6.74653 12.1701 6.27083 11.5833 6.27083H7.33333ZM7.33333 11.9375C6.74653 11.9375 6.27083 12.4132 6.27083 13C6.27083 13.5868 6.74653 14.0625 7.33333 14.0625H18.6667C19.2535 14.0625 19.7292 13.5868 19.7292 13C19.7292 12.4132 19.2535 11.9375 18.6667 11.9375H7.33333ZM7.33333 17.6042C6.74653 17.6042 6.27083 18.0799 6.27083 18.6667C6.27083 19.2535 6.74653 19.7292 7.33333 19.7292H11.5833C12.1701 19.7292 12.6458 19.2535 12.6458 18.6667C12.6458 18.0799 12.1701 17.6042 11.5833 17.6042H7.33333Z"
                fill="white"/>
              <path
                d="M23.3915 18.3866C23.8284 18.3174 24.3678 18.3127 25.6574 18.3125C25.5237 20.352 25.1967 21.7297 24.3972 22.8301C23.9603 23.4315 23.4315 23.9603 22.8301 24.3972C21.7297 25.1967 20.352 25.5237 18.3125 25.6574C18.3127 24.3678 18.3174 23.8284 18.3866 23.3915C18.7947 20.8152 20.8152 18.7947 23.3915 18.3866Z"
                fill="white"/>
            </svg>
          </div>
          <div (click)="AddBlock('IMAGE')" class="button">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.67667 0.362782C9.2947 0.187479 11.3341 0.187489 13.9359 0.1875H14.0641C16.6659 0.187489 18.7053 0.187479 20.3233 0.362782C21.9745 0.541676 23.3124 0.913293 24.4547 1.74322C25.1462 2.24565 25.7544 2.85379 26.2568 3.54533C27.0867 4.68763 27.4583 6.0255 27.6372 7.67667C27.8125 9.29467 27.8125 11.3342 27.8125 13.9359V14.0085C27.8125 15.3321 27.8125 16.505 27.791 17.5424C27.7279 20.594 27.4891 22.7585 26.2568 24.4547C25.7544 25.1462 25.1462 25.7544 24.4547 26.2568C23.3124 27.0867 21.9745 27.4583 20.3233 27.6372C18.7053 27.8125 16.6659 27.8125 14.0642 27.8125H13.9359C11.3342 27.8125 9.29467 27.8125 7.67667 27.6372C6.0255 27.4583 4.68762 27.0867 3.54533 26.2568C2.87889 25.7726 2.2899 25.1902 1.79833 24.5296C1.77982 24.5047 1.76145 24.4798 1.74322 24.4547C0.913293 23.3124 0.541676 21.9745 0.362782 20.3233C0.187479 18.7053 0.187489 16.6659 0.1875 14.0641V13.9359C0.187489 11.3341 0.18748 9.2947 0.362782 7.67667C0.541676 6.0255 0.913293 4.68763 1.74322 3.54533C2.24565 2.8538 2.8538 2.24565 3.54533 1.74322C4.68763 0.913293 6.0255 0.541676 7.67667 0.362782ZM25.6809 16.4815L25.5916 16.3953C25.2006 16.0198 24.9118 15.7656 24.64 15.5727C21.5959 13.4113 17.3969 13.9837 15.0423 16.881C14.758 17.2308 14.4733 17.6971 14.0258 18.4798L13.2917 18.25C11.598 17.9113 10.7512 17.7419 9.97395 17.7584C7.89395 17.8026 5.93854 18.7589 4.62668 20.3737C4.18935 20.912 3.83479 21.5848 3.21494 22.8206C3.29139 22.9559 3.37375 23.0836 3.46238 23.2056L3.50312 23.261C3.86645 23.7493 4.30179 24.1797 4.79438 24.5376C5.51405 25.0605 6.43519 25.3653 7.90556 25.5246C9.39582 25.686 11.3203 25.6875 14 25.6875C16.6797 25.6875 18.6042 25.686 20.0944 25.5246C21.5648 25.3653 22.486 25.0605 23.2056 24.5376C23.7168 24.1663 24.1663 23.7168 24.5376 23.2056C25.3333 22.1104 25.6025 20.5912 25.6665 17.4984C25.6732 17.1741 25.6778 16.8356 25.6809 16.4815ZM12.5833 12.5833C11.0185 12.5833 9.75 11.3148 9.75 9.75C9.75 8.18519 11.0185 6.91667 12.5833 6.91667C14.1481 6.91667 15.4167 8.18519 15.4167 9.75C15.4167 11.3148 14.1481 12.5833 12.5833 12.5833Z"
                fill="#FAFAFA"/>
            </svg>
          </div>
          <div (click)="AddBlock('VIDEO')" class="button">
            <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12.7988 0.604248H12.7038C10.7605 0.604242 9.23695 0.604237 8.01246 0.704282C6.76559 0.806155 5.73552 1.01703 4.80317 1.49209C3.27043 2.27306 2.02428 3.51921 1.24331 5.05195C0.768255 5.9843 0.557376 7.01437 0.455503 8.26124C0.355458 9.48573 0.355463 11.0093 0.355469 12.9525V13.0476C0.355463 14.9909 0.355458 16.5144 0.455503 17.7389C0.557376 18.9858 0.768255 20.0159 1.24331 20.9482C2.02428 22.481 3.27043 23.7271 4.80317 24.5081C5.73552 24.9831 6.76559 25.194 8.01246 25.2959C9.23685 25.3959 10.7602 25.3959 12.7032 25.3959H12.7989C14.7419 25.3959 16.2658 25.3959 17.4901 25.2959C18.737 25.194 19.7671 24.9831 20.6994 24.5081C22.2322 23.7271 23.4783 22.481 24.2593 20.9482C24.3302 20.8091 24.3952 20.6678 24.4549 20.5239C26.1077 21.246 27.4611 21.8321 28.5598 22.1302C29.7284 22.4472 30.8668 22.5125 31.8844 21.8466C32.902 21.1808 33.298 20.1115 33.4754 18.9137C33.6472 17.7539 33.6472 16.2241 33.6471 14.3462V11.654C33.6472 9.77611 33.6472 8.24626 33.4754 7.08644C33.298 5.88868 32.902 4.8194 31.8844 4.15352C30.8668 3.48765 29.7284 3.55296 28.5598 3.86998C27.4611 4.16803 26.1077 4.7542 24.4549 5.4763C24.3952 5.33235 24.3302 5.19105 24.2593 5.05195C23.4783 3.51921 22.2322 2.27306 20.6994 1.49209C19.7671 1.01703 18.737 0.806155 17.4901 0.704282C16.2657 0.604237 14.7421 0.604242 12.7988 0.604248ZM7.08464 7.68758C6.49783 7.68758 6.02214 8.16328 6.02214 8.75008C6.02214 9.33688 6.49783 9.81258 7.08464 9.81258H12.7513C13.3381 9.81258 13.8138 9.33688 13.8138 8.75008C13.8138 8.16328 13.3381 7.68758 12.7513 7.68758H7.08464Z"
                fill="#FAFAFA"/>
            </svg>
          </div>
          <div (click)="AddBlock('AUDIO')" class="button">
            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.8333 3.50002C15.8333 2.71761 16.4676 2.08335 17.25 2.08335C22.7268 2.08335 27.1667 6.52319 27.1667 12C27.1667 17.4768 22.7268 21.9167 17.25 21.9167C16.4676 21.9167 15.8333 21.2824 15.8333 20.5C15.8333 19.7176 16.4676 19.0834 17.25 19.0834C21.162 19.0834 24.3333 15.912 24.3333 12C24.3333 8.088 21.162 4.91669 17.25 4.91669C16.4676 4.91669 15.8333 4.28242 15.8333 3.50002Z"
                fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.8333 9.16669C15.8333 8.38428 16.4676 7.75002 17.25 7.75002C19.5972 7.75002 21.5 9.65281 21.5 12C21.5 14.3472 19.5972 16.25 17.25 16.25C16.4676 16.25 15.8333 15.6158 15.8333 14.8334C15.8333 14.0509 16.4676 13.4167 17.25 13.4167C18.0324 13.4167 18.6667 12.7824 18.6667 12C18.6667 11.2176 18.0324 10.5834 17.25 10.5834C16.4676 10.5834 15.8333 9.94909 15.8333 9.16669Z"
                fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.70664 1.76218C9.14816 -0.76048 13 0.26242 13 3.1679V20.8321C13 23.7376 9.14816 24.7605 7.70664 22.2379L5.09454 17.6667H3.08333C1.51853 17.6667 0.25 16.3982 0.25 14.8334V9.16669C0.25 7.60188 1.51853 6.33335 3.08333 6.33335H5.09454L7.70664 1.76218Z"
                fill="white"/>
            </svg>
          </div>
          <div (click)="AddBlock('IFRAME')" class="button">
            <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#002aff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"/>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
              <g id="SVGRepo_iconCarrier"> <path d="M16.4425 7.32787C16.7196 7.01999 17.1938 6.99503 17.5017 7.27213L19.2392 8.83587C19.9756 9.49853 20.5864 10.0482 21.0058 10.5468C21.4468 11.071 21.7603 11.6343 21.7603 12.3296C21.7603 13.0249 21.4468 13.5882 21.0058 14.1124C20.5864 14.611 19.9756 15.1607 19.2392 15.8233L17.5017 17.3871C17.1938 17.6642 16.7196 17.6392 16.4425 17.3313C16.1654 17.0234 16.1904 16.5492 16.4983 16.2721L18.1947 14.7453C18.9826 14.0362 19.5138 13.5558 19.8579 13.1468C20.1882 12.7542 20.2603 12.525 20.2603 12.3296C20.2603 12.1342 20.1882 11.905 19.8579 11.5124C19.5138 11.1034 18.9826 10.623 18.1947 9.91389L16.4983 8.38707C16.1904 8.10997 16.1654 7.63576 16.4425 7.32787Z" fill="#1C274C"/> <path d="M7.50178 8.38707C7.80966 8.10997 7.83462 7.63576 7.55752 7.32787C7.28043 7.01999 6.80621 6.99503 6.49833 7.27213L4.76084 8.83587C4.0245 9.49853 3.41369 10.0482 2.99428 10.5468C2.55325 11.071 2.23975 11.6343 2.23975 12.3296C2.23975 13.0249 2.55325 13.5882 2.99428 14.1124C3.41369 14.611 4.02449 15.1607 4.76082 15.8233L6.49833 17.3871C6.80621 17.6642 7.28043 17.6392 7.55752 17.3313C7.83462 17.0234 7.80966 16.5492 7.50178 16.2721L5.80531 14.7453C5.01743 14.0362 4.48623 13.5558 4.14213 13.1468C3.81188 12.7542 3.73975 12.525 3.73975 12.3296C3.73975 12.1342 3.81188 11.905 4.14213 11.5124C4.48623 11.1034 5.01743 10.623 5.80531 9.91389L7.50178 8.38707Z" fill="#1C274C"/> <path d="M14.1816 4.2755C14.5817 4.3827 14.8191 4.79396 14.7119 5.19406L10.7383 20.0238C10.6311 20.4239 10.2198 20.6613 9.81974 20.5541C9.41964 20.4469 9.18221 20.0356 9.28941 19.6355L13.263 4.80583C13.3702 4.40573 13.7815 4.16829 14.1816 4.2755Z" fill="#1C274C"/> </g>
            </svg>
          </div>
          <div (click)="AddBlock('PARTNER')" class="button">
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4 2.94737H11.2V1.47368C11.2 0.655789 10.488 0 9.6 0H6.4C5.512 0 4.8 0.655789 4.8 1.47368V2.94737H1.6C0.712 2.94737 0.00799999 3.60316 0.00799999 4.42105L0 12.5263C0 13.3442 0.712 14 1.6 14H14.4C15.288 14 16 13.3442 16 12.5263V4.42105C16 3.60316 15.288 2.94737 14.4 2.94737ZM9.6 2.94737H6.4V1.47368H9.6V2.94737Z" fill="#FF6633"/></svg>
          </div>
        </div>
        <div class="add-tools">
          <div class="block">
            <img [hidden]="!SelectedItem" class="image plus-block" src="assets/icons/lesson-content/replace.svg">
            <div (click)="AddBlock('TEXT')" class="button" tooltip="Текст">
              <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.75 2.79175C8.75 3.96758 9.69917 4.91675 10.875 4.91675H15.8333V19.7917C15.8333 20.9676 16.7825 21.9167 17.9583 21.9167C19.1342 21.9167 20.0833 20.9676 20.0833 19.7917V4.91675H25.0417C26.2175 4.91675 27.1667 3.96758 27.1667 2.79175C27.1667 1.61591 26.2175 0.666748 25.0417 0.666748H10.875C9.69917 0.666748 8.75 1.61591 8.75 2.79175ZM2.375 12.0001H4.5V19.7917C4.5 20.9676 5.44917 21.9167 6.625 21.9167C7.80083 21.9167 8.75 20.9676 8.75 19.7917V12.0001H10.875C12.0508 12.0001 13 11.0509 13 9.87508C13 8.69925 12.0508 7.75008 10.875 7.75008H2.375C1.19917 7.75008 0.25 8.69925 0.25 9.87508C0.25 11.0509 1.19917 12.0001 2.375 12.0001Z"
                  fill="white"/>
              </svg>
              <!--<img class="image" src="assets/icons/lesson-content/text.svg">-->
            </div>
            <div (click)="AddBlock('FILE')" class="button" tooltip="Файл">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0.25 13C0.25 7.68788 0.25 5.03182 1.6028 3.16985C2.03969 2.56852 2.56852 2.03969 3.16985 1.6028C5.03182 0.25 7.68788 0.25 13 0.25C18.3121 0.25 20.9682 0.25 22.8301 1.6028C23.4315 2.03969 23.9603 2.56852 24.3972 3.16985C25.75 5.03182 25.75 7.68788 25.75 13C25.75 14.1885 25.75 15.2441 25.7348 16.1875L25.6355 16.1875C24.4285 16.1874 23.6933 16.1873 23.059 16.2878C19.5735 16.8398 16.8398 19.5735 16.2878 23.059C16.1873 23.6933 16.1874 24.4285 16.1875 25.6355L16.1875 25.7348C15.2441 25.75 14.1885 25.75 13 25.75C7.68788 25.75 5.03182 25.75 3.16985 24.3972C2.56852 23.9603 2.03969 23.4315 1.6028 22.8301C0.25 20.9682 0.25 18.3121 0.25 13ZM7.33333 6.27083C6.74653 6.27083 6.27083 6.74653 6.27083 7.33333C6.27083 7.92014 6.74653 8.39583 7.33333 8.39583H11.5833C12.1701 8.39583 12.6458 7.92014 12.6458 7.33333C12.6458 6.74653 12.1701 6.27083 11.5833 6.27083H7.33333ZM7.33333 11.9375C6.74653 11.9375 6.27083 12.4132 6.27083 13C6.27083 13.5868 6.74653 14.0625 7.33333 14.0625H18.6667C19.2535 14.0625 19.7292 13.5868 19.7292 13C19.7292 12.4132 19.2535 11.9375 18.6667 11.9375H7.33333ZM7.33333 17.6042C6.74653 17.6042 6.27083 18.0799 6.27083 18.6667C6.27083 19.2535 6.74653 19.7292 7.33333 19.7292H11.5833C12.1701 19.7292 12.6458 19.2535 12.6458 18.6667C12.6458 18.0799 12.1701 17.6042 11.5833 17.6042H7.33333Z"
                  fill="white"/>
                <path
                  d="M23.3915 18.3866C23.8284 18.3174 24.3678 18.3127 25.6574 18.3125C25.5237 20.352 25.1967 21.7297 24.3972 22.8301C23.9603 23.4315 23.4315 23.9603 22.8301 24.3972C21.7297 25.1967 20.352 25.5237 18.3125 25.6574C18.3127 24.3678 18.3174 23.8284 18.3866 23.3915C18.7947 20.8152 20.8152 18.7947 23.3915 18.3866Z"
                  fill="white"/>
              </svg>
            </div>
            <div (click)="AddBlock('IMAGE')" class="button" tooltip="Изображение">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.67667 0.362782C9.2947 0.187479 11.3341 0.187489 13.9359 0.1875H14.0641C16.6659 0.187489 18.7053 0.187479 20.3233 0.362782C21.9745 0.541676 23.3124 0.913293 24.4547 1.74322C25.1462 2.24565 25.7544 2.85379 26.2568 3.54533C27.0867 4.68763 27.4583 6.0255 27.6372 7.67667C27.8125 9.29467 27.8125 11.3342 27.8125 13.9359V14.0085C27.8125 15.3321 27.8125 16.505 27.791 17.5424C27.7279 20.594 27.4891 22.7585 26.2568 24.4547C25.7544 25.1462 25.1462 25.7544 24.4547 26.2568C23.3124 27.0867 21.9745 27.4583 20.3233 27.6372C18.7053 27.8125 16.6659 27.8125 14.0642 27.8125H13.9359C11.3342 27.8125 9.29467 27.8125 7.67667 27.6372C6.0255 27.4583 4.68762 27.0867 3.54533 26.2568C2.87889 25.7726 2.2899 25.1902 1.79833 24.5296C1.77982 24.5047 1.76145 24.4798 1.74322 24.4547C0.913293 23.3124 0.541676 21.9745 0.362782 20.3233C0.187479 18.7053 0.187489 16.6659 0.1875 14.0641V13.9359C0.187489 11.3341 0.18748 9.2947 0.362782 7.67667C0.541676 6.0255 0.913293 4.68763 1.74322 3.54533C2.24565 2.8538 2.8538 2.24565 3.54533 1.74322C4.68763 0.913293 6.0255 0.541676 7.67667 0.362782ZM25.6809 16.4815L25.5916 16.3953C25.2006 16.0198 24.9118 15.7656 24.64 15.5727C21.5959 13.4113 17.3969 13.9837 15.0423 16.881C14.758 17.2308 14.4733 17.6971 14.0258 18.4798L13.2917 18.25C11.598 17.9113 10.7512 17.7419 9.97395 17.7584C7.89395 17.8026 5.93854 18.7589 4.62668 20.3737C4.18935 20.912 3.83479 21.5848 3.21494 22.8206C3.29139 22.9559 3.37375 23.0836 3.46238 23.2056L3.50312 23.261C3.86645 23.7493 4.30179 24.1797 4.79438 24.5376C5.51405 25.0605 6.43519 25.3653 7.90556 25.5246C9.39582 25.686 11.3203 25.6875 14 25.6875C16.6797 25.6875 18.6042 25.686 20.0944 25.5246C21.5648 25.3653 22.486 25.0605 23.2056 24.5376C23.7168 24.1663 24.1663 23.7168 24.5376 23.2056C25.3333 22.1104 25.6025 20.5912 25.6665 17.4984C25.6732 17.1741 25.6778 16.8356 25.6809 16.4815ZM12.5833 12.5833C11.0185 12.5833 9.75 11.3148 9.75 9.75C9.75 8.18519 11.0185 6.91667 12.5833 6.91667C14.1481 6.91667 15.4167 8.18519 15.4167 9.75C15.4167 11.3148 14.1481 12.5833 12.5833 12.5833Z"
                  fill="#FAFAFA"/>
              </svg>
            </div>
            <div (click)="AddBlock('VIDEO')" class="button" tooltip="Видео по ссылке">
              <svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.7988 0.604248H12.7038C10.7605 0.604242 9.23695 0.604237 8.01246 0.704282C6.76559 0.806155 5.73552 1.01703 4.80317 1.49209C3.27043 2.27306 2.02428 3.51921 1.24331 5.05195C0.768255 5.9843 0.557376 7.01437 0.455503 8.26124C0.355458 9.48573 0.355463 11.0093 0.355469 12.9525V13.0476C0.355463 14.9909 0.355458 16.5144 0.455503 17.7389C0.557376 18.9858 0.768255 20.0159 1.24331 20.9482C2.02428 22.481 3.27043 23.7271 4.80317 24.5081C5.73552 24.9831 6.76559 25.194 8.01246 25.2959C9.23685 25.3959 10.7602 25.3959 12.7032 25.3959H12.7989C14.7419 25.3959 16.2658 25.3959 17.4901 25.2959C18.737 25.194 19.7671 24.9831 20.6994 24.5081C22.2322 23.7271 23.4783 22.481 24.2593 20.9482C24.3302 20.8091 24.3952 20.6678 24.4549 20.5239C26.1077 21.246 27.4611 21.8321 28.5598 22.1302C29.7284 22.4472 30.8668 22.5125 31.8844 21.8466C32.902 21.1808 33.298 20.1115 33.4754 18.9137C33.6472 17.7539 33.6472 16.2241 33.6471 14.3462V11.654C33.6472 9.77611 33.6472 8.24626 33.4754 7.08644C33.298 5.88868 32.902 4.8194 31.8844 4.15352C30.8668 3.48765 29.7284 3.55296 28.5598 3.86998C27.4611 4.16803 26.1077 4.7542 24.4549 5.4763C24.3952 5.33235 24.3302 5.19105 24.2593 5.05195C23.4783 3.51921 22.2322 2.27306 20.6994 1.49209C19.7671 1.01703 18.737 0.806155 17.4901 0.704282C16.2657 0.604237 14.7421 0.604242 12.7988 0.604248ZM7.08464 7.68758C6.49783 7.68758 6.02214 8.16328 6.02214 8.75008C6.02214 9.33688 6.49783 9.81258 7.08464 9.81258H12.7513C13.3381 9.81258 13.8138 9.33688 13.8138 8.75008C13.8138 8.16328 13.3381 7.68758 12.7513 7.68758H7.08464Z"
                  fill="#FAFAFA"/>
              </svg>
            </div>
            <div (click)="AddBlock('AUDIO')" class="button" tooltip="Аудио">
              <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.8333 3.50002C15.8333 2.71761 16.4676 2.08335 17.25 2.08335C22.7268 2.08335 27.1667 6.52319 27.1667 12C27.1667 17.4768 22.7268 21.9167 17.25 21.9167C16.4676 21.9167 15.8333 21.2824 15.8333 20.5C15.8333 19.7176 16.4676 19.0834 17.25 19.0834C21.162 19.0834 24.3333 15.912 24.3333 12C24.3333 8.088 21.162 4.91669 17.25 4.91669C16.4676 4.91669 15.8333 4.28242 15.8333 3.50002Z"
                  fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.8333 9.16669C15.8333 8.38428 16.4676 7.75002 17.25 7.75002C19.5972 7.75002 21.5 9.65281 21.5 12C21.5 14.3472 19.5972 16.25 17.25 16.25C16.4676 16.25 15.8333 15.6158 15.8333 14.8334C15.8333 14.0509 16.4676 13.4167 17.25 13.4167C18.0324 13.4167 18.6667 12.7824 18.6667 12C18.6667 11.2176 18.0324 10.5834 17.25 10.5834C16.4676 10.5834 15.8333 9.94909 15.8333 9.16669Z"
                  fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.70664 1.76218C9.14816 -0.76048 13 0.26242 13 3.1679V20.8321C13 23.7376 9.14816 24.7605 7.70664 22.2379L5.09454 17.6667H3.08333C1.51853 17.6667 0.25 16.3982 0.25 14.8334V9.16669C0.25 7.60188 1.51853 6.33335 3.08333 6.33335H5.09454L7.70664 1.76218Z"
                  fill="white"/>
              </svg>
            </div>
            <div (click)="AddBlock('IFRAME')" tooltip="iframe" class="button">
              <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#002aff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                <g id="SVGRepo_iconCarrier"> <path d="M16.4425 7.32787C16.7196 7.01999 17.1938 6.99503 17.5017 7.27213L19.2392 8.83587C19.9756 9.49853 20.5864 10.0482 21.0058 10.5468C21.4468 11.071 21.7603 11.6343 21.7603 12.3296C21.7603 13.0249 21.4468 13.5882 21.0058 14.1124C20.5864 14.611 19.9756 15.1607 19.2392 15.8233L17.5017 17.3871C17.1938 17.6642 16.7196 17.6392 16.4425 17.3313C16.1654 17.0234 16.1904 16.5492 16.4983 16.2721L18.1947 14.7453C18.9826 14.0362 19.5138 13.5558 19.8579 13.1468C20.1882 12.7542 20.2603 12.525 20.2603 12.3296C20.2603 12.1342 20.1882 11.905 19.8579 11.5124C19.5138 11.1034 18.9826 10.623 18.1947 9.91389L16.4983 8.38707C16.1904 8.10997 16.1654 7.63576 16.4425 7.32787Z" fill="#1C274C"/> <path d="M7.50178 8.38707C7.80966 8.10997 7.83462 7.63576 7.55752 7.32787C7.28043 7.01999 6.80621 6.99503 6.49833 7.27213L4.76084 8.83587C4.0245 9.49853 3.41369 10.0482 2.99428 10.5468C2.55325 11.071 2.23975 11.6343 2.23975 12.3296C2.23975 13.0249 2.55325 13.5882 2.99428 14.1124C3.41369 14.611 4.02449 15.1607 4.76082 15.8233L6.49833 17.3871C6.80621 17.6642 7.28043 17.6392 7.55752 17.3313C7.83462 17.0234 7.80966 16.5492 7.50178 16.2721L5.80531 14.7453C5.01743 14.0362 4.48623 13.5558 4.14213 13.1468C3.81188 12.7542 3.73975 12.525 3.73975 12.3296C3.73975 12.1342 3.81188 11.905 4.14213 11.5124C4.48623 11.1034 5.01743 10.623 5.80531 9.91389L7.50178 8.38707Z" fill="#1C274C"/> <path  d="M14.1816 4.2755C14.5817 4.3827 14.8191 4.79396 14.7119 5.19406L10.7383 20.0238C10.6311 20.4239 10.2198 20.6613 9.81974 20.5541C9.41964 20.4469 9.18221 20.0356 9.28941 19.6355L13.263 4.80583C13.3702 4.40573 13.7815 4.16829 14.1816 4.2755Z" fill="#1C274C"/> </g>
              </svg>
            </div>
            <div (click)="AddBlock('PARTNER')" class="button" tooltip="Партнер">
              <svg width="28" height="24" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4 2.94737H11.2V1.47368C11.2 0.655789 10.488 0 9.6 0H6.4C5.512 0 4.8 0.655789 4.8 1.47368V2.94737H1.6C0.712 2.94737 0.00799999 3.60316 0.00799999 4.42105L0 12.5263C0 13.3442 0.712 14 1.6 14H14.4C15.288 14 16 13.3442 16 12.5263V4.42105C16 3.60316 15.288 2.94737 14.4 2.94737ZM9.6 2.94737H6.4V1.47368H9.6V2.94737Z" fill="#FF6633"/></svg>
            </div>
            <div (click)="AddBlock('VIDEO_STREAM')" class="button" tooltip="Видео-файл">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.75 13C25.75 7.68788 25.75 5.03182 24.3972 3.16985C23.9603 2.56852 23.4315 2.03969 22.8301 1.6028C20.9682 0.25 18.3121 0.25 13 0.25C11.8115 0.25 10.7559 0.25 9.8125 0.265151L9.81251 0.364495C9.8126 1.57152 9.81266 2.30675 9.71221 2.94096C9.16016 6.4265 6.4265 9.16016 2.94096 9.71221C2.30675 9.81266 1.57152 9.8126 0.364496 9.81251L0.265152 9.8125C0.25 10.7559 0.25 11.8115 0.25 13C0.25 18.3121 0.25 20.9682 1.6028 22.8301C2.03969 23.4315 2.56852 23.9603 3.16986 24.3972C5.03182 25.75 7.68788 25.75 13 25.75C18.3121 25.75 20.9682 25.75 22.8301 24.3972C23.4315 23.9603 23.9603 23.4315 24.3972 22.8301C25.75 20.9682 25.75 18.3121 25.75 13ZM13.3542 10.1667C13.3542 9.57986 13.8299 9.10417 14.4167 9.10417C15.0035 9.10417 15.4792 9.57986 15.4792 10.1667L15.4792 13.3542H18.6667C19.2535 13.3542 19.7292 13.8299 19.7292 14.4167C19.7292 15.0035 19.2535 15.4792 18.6667 15.4792H15.4792V18.6667C15.4792 19.2535 15.0035 19.7292 14.4167 19.7292C13.8299 19.7292 13.3542 19.2535 13.3542 18.6667V15.4792H10.1667C9.57986 15.4792 9.10417 15.0035 9.10417 14.4167C9.10417 13.8299 9.57986 13.3542 10.1667 13.3542H13.3542V10.1667Z" fill="white"/>
                <path d="M7.61337 2.60853C7.68257 2.17165 7.68731 1.63221 7.68749 0.34256C5.64803 0.476304 4.27026 0.803302 3.16986 1.6028C2.56852 2.03969 2.03969 2.56852 1.6028 3.16985C0.803303 4.27026 0.476305 5.64803 0.34256 7.68749C1.63221 7.68731 2.17165 7.68257 2.60853 7.61337C5.1848 7.20533 7.20533 5.1848 7.61337 2.60853Z" fill="white"/>
              </svg>
            </div>
          </div>
          <div class="block">
            <div (click)="AddSplit(2)" class="button" tooltip="2 колонки">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" version="1.1"
                viewBox="0.00 0.00 512.00 512.00">
            <path fill="#ffffff" d="
  M 0.00 44.85
  L 0.00 41.06
  Q 1.95 31.71 9.46 28.46
  Q 12.83 27.01 15.99 27.01
  Q 119.70 26.99 217.68 26.99
  C 224.49 26.99 230.00 30.01 233.05 36.17
  C 237.16 44.47 232.80 55.11 223.99 58.02
  Q 221.02 59.00 216.89 59.00
  Q 116.96 58.91 22.02 59.08
  Q 13.10 59.10 9.28 57.42
  Q 2.01 54.23 0.00 44.85
  Z"
                  />
            <path fill="#ffffff" d="
  M 512.00 41.18
  L 512.00 44.72
  Q 510.11 54.25 502.50 57.52
  Q 499.09 58.98 494.81 58.98
  Q 393.54 59.02 293.78 59.01
  C 286.16 59.01 279.42 53.93 277.76 46.50
  C 275.50 36.40 283.23 26.96 293.57 26.97
  Q 395.46 27.08 491.94 26.92
  Q 498.98 26.91 502.73 28.56
  Q 509.96 31.75 512.00 41.18
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 151.36
  L 0.00 147.78
  Q 1.87 138.43 9.55 135.10
  Q 12.72 133.73 15.98 133.73
  Q 117.56 133.73 218.81 133.72
  C 225.44 133.72 231.17 137.93 233.54 144.01
  C 237.38 153.87 230.12 165.63 219.09 165.63
  Q 116.09 165.62 16.24 165.64
  C 7.72 165.64 1.66 159.87 0.00 151.36
  Z"
                  />
            <path fill="#ffffff" d="
  M 512.00 147.93
  L 512.00 151.46
  Q 510.06 160.88 502.64 164.12
  Q 499.04 165.69 493.37 165.68
  Q 394.52 165.55 295.93 165.67
  Q 290.07 165.68 287.02 164.30
  C 274.04 158.44 274.18 139.99 287.57 134.78
  Q 290.30 133.72 292.76 133.72
  Q 392.90 133.75 493.57 133.67
  Q 499.22 133.67 502.87 135.30
  Q 510.03 138.51 512.00 147.93
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 258.11
  L 0.00 254.53
  Q 1.87 245.10 9.38 241.84
  Q 12.84 240.35 16.45 240.35
  Q 120.18 240.42 217.31 240.31
  C 225.38 240.30 231.95 244.42 234.08 252.35
  C 236.11 259.95 232.13 267.89 224.97 270.98
  Q 221.86 272.32 217.11 272.31
  Q 116.90 272.22 15.96 272.33
  C 7.59 272.34 1.41 265.96 0.00 258.11
  Z"
                  />
            <path fill="#ffffff" d="
  M 512.00 254.66
  L 512.00 258.22
  Q 508.79 272.29 493.75 272.29
  Q 391.60 272.26 296.09 272.28
  Q 289.95 272.28 287.11 271.01
  C 270.83 263.71 276.23 240.32 293.94 240.33
  Q 391.70 240.38 495.70 240.33
  C 504.28 240.33 510.31 246.08 512.00 254.66
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 364.85
  L 0.00 361.04
  Q 1.96 351.70 9.47 348.46
  Q 12.89 346.99 16.22 346.99
  Q 117.97 346.98 218.66 347.04
  C 231.71 347.05 239.52 362.28 231.23 372.76
  C 227.38 377.63 222.56 379.09 216.47 379.08
  Q 119.40 378.83 22.61 379.09
  Q 13.14 379.12 9.28 377.42
  Q 2.01 374.23 0.00 364.85
  Z"
                  />
            <path fill="#ffffff" d="
  M 512.00 361.16
  L 512.00 364.72
  Q 510.11 374.25 502.50 377.52
  Q 499.07 378.99 495.01 378.99
  Q 393.55 379.01 293.82 378.99
  C 286.07 378.99 279.43 373.94 277.75 366.43
  C 276.09 358.95 279.99 351.44 286.88 348.41
  Q 290.24 346.94 296.03 346.94
  Q 393.21 347.11 491.53 346.90
  Q 498.95 346.89 502.75 348.58
  Q 509.99 351.79 512.00 361.16
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 471.35
  L 0.00 467.78
  Q 1.87 458.43 9.55 455.10
  Q 12.71 453.73 15.76 453.73
  Q 117.56 453.71 218.72 453.75
  C 230.17 453.75 237.80 465.55 233.30 475.91
  C 230.35 482.70 224.52 485.64 217.25 485.65
  Q 123.57 485.71 17.64 485.61
  Q 12.84 485.60 9.49 484.17
  Q 1.86 480.89 0.00 471.35
  Z"
                  />
            <path fill="#ffffff" d="
  M 512.00 467.93
  L 512.00 471.44
  Q 510.08 480.91 502.54 484.16
  Q 498.85 485.75 491.71 485.73
  Q 391.96 485.43 297.47 485.73
  Q 290.63 485.75 287.49 484.50
  C 271.21 477.98 275.79 453.71 293.40 453.72
  Q 393.04 453.78 493.95 453.70
  Q 499.29 453.70 502.87 455.30
  Q 510.03 458.51 512.00 467.93
  Z"
                  />
              </svg>
            </div>
            <div (click)="AddSplit(3)" class="button" tooltip="3 колонки">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" version="1.1"
                viewBox="0.00 0.00 512.00 512.00">
            <path fill="#ffffff" d="
  M 0.00 44.86
  L 0.00 41.06
  Q 1.98 31.72 9.35 28.51
  Q 12.89 26.97 19.40 26.99
  Q 65.25 27.14 110.81 26.90
  C 118.15 26.87 124.23 30.57 126.96 37.51
  C 130.90 47.53 122.94 59.02 112.29 59.00
  Q 63.08 58.89 20.94 59.09
  Q 13.15 59.13 9.28 57.42
  Q 2.01 54.22 0.00 44.86
  Z"
                  />
                <rect fill="#ffffff" x="192.12" y="27.04" width="127.74" height="31.92" rx="15.55"/>
            <path fill="#ffffff" d="
  M 512.00 41.18
  L 512.00 44.72
  Q 510.06 54.21 502.70 57.44
  Q 498.86 59.12 491.13 59.09
  Q 444.96 58.89 401.05 59.04
  C 394.96 59.06 389.09 56.25 386.25 51.05
  C 380.05 39.72 387.79 26.93 400.72 26.97
  Q 444.02 27.10 493.18 26.91
  Q 498.86 26.89 502.57 28.50
  Q 510.01 31.74 512.00 41.18
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 151.36
  L 0.00 147.78
  Q 1.87 138.43 9.57 135.09
  Q 12.85 133.67 16.56 133.68
  Q 61.87 133.83 107.89 133.66
  Q 115.16 133.63 117.94 134.83
  Q 125.46 138.05 127.50 146.08
  C 129.45 153.75 124.98 161.87 117.56 164.60
  Q 114.43 165.74 109.68 165.72
  Q 64.00 165.50 17.94 165.70
  C 8.54 165.74 1.90 161.12 0.00 151.36
  Z"
                  />
                <rect fill="#ffffff" x="-63.87" y="-15.92" transform="translate(256.00,149.67) rotate(-0.1)" width="127.74"
                  height="31.84" rx="15.51"/>
            <path fill="#ffffff" d="
  M 512.00 147.90
  L 512.00 151.46
  Q 510.05 160.92 502.55 164.16
  Q 498.84 165.76 492.88 165.73
  Q 447.65 165.48 403.85 165.71
  Q 396.99 165.75 393.88 164.39
  C 380.95 158.77 380.69 140.72 393.69 135.01
  Q 396.78 133.66 402.47 133.68
  Q 448.26 133.86 494.25 133.70
  Q 508.86 133.64 512.00 147.90
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 258.11
  L 0.00 254.53
  Q 1.87 245.10 9.38 241.84
  Q 13.20 240.19 18.68 240.23
  Q 66.27 240.59 112.20 240.41
  C 128.98 240.35 134.41 264.35 117.95 271.13
  Q 115.11 272.30 111.15 272.29
  Q 62.84 272.22 16.19 272.30
  C 7.65 272.32 1.46 266.20 0.00 258.11
  Z"
                  />
                <rect fill="#ffffff" x="-63.87" y="-15.93" transform="translate(256.00,256.32) rotate(-0.1)" width="127.74"
                  height="31.86" rx="15.52"/>
            <path fill="#ffffff" d="
  M 512.00 254.66
  L 512.00 258.23
  Q 508.79 272.31 493.75 272.30
  Q 447.91 272.26 402.07 272.27
  Q 397.55 272.27 394.66 271.31
  Q 390.34 269.88 387.74 266.49
  C 379.15 255.24 386.50 240.33 400.80 240.35
  Q 449.25 240.40 493.34 240.30
  Q 498.98 240.29 502.54 241.82
  Q 510.12 245.10 512.00 254.66
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 364.86
  L 0.00 361.04
  Q 1.97 351.67 9.55 348.43
  Q 12.95 346.97 16.37 346.98
  Q 61.71 347.07 108.55 346.93
  Q 115.40 346.91 118.32 348.29
  C 134.22 355.78 129.11 379.01 111.72 379.00
  Q 59.74 378.97 17.27 379.03
  C 8.25 379.04 1.98 374.08 0.00 364.86
  Z"
                  />
                <rect fill="#ffffff" x="192.12" y="347.04" width="127.74" height="31.92" rx="15.55"/>
            <path fill="#ffffff" d="
  M 512.00 361.16
  L 512.00 364.73
  Q 509.98 374.44 502.41 377.57
  Q 498.58 379.15 490.34 379.11
  Q 447.58 378.87 400.84 378.99
  C 386.05 379.03 379.01 363.20 388.22 352.27
  C 391.72 348.11 396.74 346.94 401.96 346.95
  Q 448.65 347.07 491.53 346.94
  Q 498.99 346.92 502.70 348.55
  Q 509.99 351.77 512.00 361.16
  Z"
                  />
            <path fill="#ffffff" d="
  M 0.00 471.36
  L 0.00 467.78
  Q 1.87 458.43 9.55 455.10
  Q 12.83 453.68 17.07 453.69
  Q 64.65 453.80 111.16 453.68
  C 118.88 453.66 125.19 458.00 127.36 465.35
  C 130.22 475.06 122.64 485.62 112.38 485.63
  Q 60.58 485.63 16.06 485.63
  C 7.64 485.63 1.63 479.73 0.00 471.36
  Z"
                  />
                <rect fill="#ffffff" x="-63.87" y="-15.92" transform="translate(256.00,469.67) rotate(-0.1)" width="127.74"
                  height="31.84" rx="15.51"/>
            <path fill="#ffffff" d="
  M 512.00 467.90
  L 512.00 471.45
  Q 510.08 480.93 502.48 484.19
  Q 499.02 485.67 495.64 485.67
  Q 448.66 485.56 402.48 485.69
  Q 396.92 485.70 393.88 484.39
  C 381.00 478.83 380.70 460.94 393.52 455.07
  Q 396.57 453.67 402.47 453.69
  Q 451.13 453.85 494.25 453.70
  Q 508.86 453.64 512.00 467.90
  Z"
                  />
              </svg>
            </div>
          </div>
          <div class="block">
            <div (click)="OpenLesson()" class="button" tooltip="Режим просмотра">
              <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.9979 0.666748C12.2526 0.666748 8.93369 2.62979 6.43791 4.72216C3.91793 6.83482 2.05338 9.23353 1.19186 10.4318C0.514171 11.3744 0.514172 12.6257 1.19186 13.5683C2.05338 14.7666 3.91793 17.1653 6.43791 19.278C8.93369 21.3704 12.2526 23.3334 15.9979 23.3334C19.7432 23.3334 23.0621 21.3704 25.5579 19.278C28.0779 17.1653 29.9424 14.7666 30.8039 13.5683C31.4816 12.6257 31.4816 11.3744 30.8039 10.4318C29.9424 9.23353 28.0779 6.83482 25.5579 4.72216C23.0621 2.62979 19.7432 0.666748 15.9979 0.666748ZM15.9985 19.0834C19.9106 19.0834 23.0819 15.9121 23.0819 12.0001C23.0819 8.08806 19.9106 4.91675 15.9985 4.91675C12.0865 4.91675 8.9152 8.08806 8.9152 12.0001C8.9152 15.9121 12.0865 19.0834 15.9985 19.0834Z"
                  fill="white"/>
                <path
                  d="M20.2485 12.0001C20.2485 14.3473 18.3457 16.2501 15.9985 16.2501C13.6513 16.2501 11.7485 14.3473 11.7485 12.0001C11.7485 9.65287 13.6513 7.75008 15.9985 7.75008C18.3457 7.75008 20.2485 9.65287 20.2485 12.0001Z"
                  fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
